<template>
  <v-menu
    ref="label"
    :close-on-content-click="false"
    v-model="showPicker"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <v-text-field
      :label="label"
      slot="activator"
      v-model="formatedDate"
      mask="##.##.####"
      return-masked-value
      placeholder="дд.мм.гггг"
      hide-details
      append-icon="event"
      @blur="parseDate(formatedDate)"
      @keyup.enter="parseDate(formatedDate); showPicker = false"
    ></v-text-field>
    <v-date-picker v-model="utcDate" :first-day-of-week="1" locale="ru" no-title @input="formatDate(utcDate)"></v-date-picker>
  </v-menu>
</template>

<script>
  export default {
    name : "dDatePicker",
    
    props: {
      label: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      valueFormatted: {
        type: String,
        default: ''
      }
    },
    
    data(){
      return {
        utcDate: '',
        formatedDate: '',
        showPicker: false
      }
    },
    
    mounted(){
      if(this.value && this.value.indexOf("-")>=0){
        this.formatDate(this.value)
      } else {
        this.formatedDate = this.value
      }
      this.parseDate(this.formatedDate)
    },
    
    methods: {
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        this.formatedDate = `${day}.${month}.${year}`
        this.$emit('input', this.formatedDate)
        this.showPicker = false
      },
  
      parseDate (date) {
        if (!date) return null
        
        const [day, month, year] = date.split('.')
        this.utcDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        this.$emit('input', this.formatedDate)
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Common/dDatePicker.vue